var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"BingoBoard3",attrs:{"name":"BingoBoard3","tag":"div"},on:{"before-leave":_vm.beforeLeave}},_vm._l((_vm.cells),function(cell,i){return _c('div',{key:cell.key,staticClass:"cell-container",style:({zIndex: i})},[_c('div',{class:{
				     cell: true,
				     '-selected': cell.selected,
				     '-star': i === 4,
				  },on:{"click":function($event){_vm.$emit('select', i)}}},[(i === 4)?_c('span',{staticClass:"icon"},[_vm._v("★")]):_c('span',{staticClass:"text"},[_vm._v(_vm._s(cell.text))])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eccd22b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BingoBoard3.vue
// module id = null
// module chunks = 